export const CONTACT = {
  email: "admin@rhettco.org",
  phone: "839-213-2108",
  phoneHref: "tel:+18392132108",
  location: "Charlotte, North Carolina",
  serving: "The Carolinas and clients nationwide",
  website: "therhettco.org",
  socials: [
    { handle: "@therhettco", label: "The Rhett Co", url: "https://instagram.com/therhettco" },
    { handle: "@_reggierhett", label: "Reggie Rhett", url: "https://instagram.com/_reggierhett" },
    { handle: "@iam_chaquannaiman", label: "Chaquanna Iman", url: "https://instagram.com/iam_chaquannaiman" },
  ],
};

export const ABOUT = {
  intro:
    "The Rhett Co LLC is a creative services and consulting company based in Charlotte, North Carolina, serving churches, artists, and creative organizations.",
  body:
    "Founded by Reggie and Chaquanna Rhett, The Rhett Co brings together music production, worship leadership, and strategic consulting to help clients develop leaders, strengthen creative teams, and bring their vision to life.",
  mission:
    "To empower churches, artists, and creative organizations through creative excellence, purposeful leadership, and professional music services.",
  vision:
    "To become a trusted creative partner known for developing leaders, strengthening worship environments, and producing exceptional music.",
};

export const LEADERS = [
  {
    initial: "R",
    name: "Reginald Rhett",
    role: "Co-Founder",
    craft: "Producer · Mixing Engineer · Music Director",
    bio: "Music producer, mixing engineer, multi-instrumentalist, and music director with a degree in Music Production from Full Sail University. Reggie brings experience in professional music production, worship leadership, and church consulting.",
    social: "@_reggierhett",
    url: "https://instagram.com/_reggierhett",
  },
  {
    initial: "C",
    name: "Chaquanna Iman Rhett",
    role: "Co-Founder",
    craft: "Recording Artist · Worship Leader",
    bio: "Recording artist and worship leader with a bachelor's degree from Columbia College. Chaquanna is passionate about developing worship leaders, strengthening teams, and cultivating healthy worship environments.",
    social: "@iam_chaquannaiman",
    url: "https://instagram.com/iam_chaquannaiman",
  },
];

export const SERVICES = [
  {
    id: "consulting",
    no: "01",
    title: "Church Consulting & Worship Development",
    intro:
      "We help churches build stronger worship departments, develop leaders, and create effective systems that support long-term ministry growth.",
    items: [
      "Worship department consulting and development",
      "Worship leader coaching and team training",
      "Church audio and production consulting",
      "Rehearsal systems and team development",
      "Worship ministry strategy and leadership development",
    ],
    bestFor: "Churches looking to strengthen their worship ministry, improve production, or develop their teams.",
    pricing: "Custom consulting packages and project-based proposals.",
    image: "/images/consulting-stage.webp",
  },
  {
    id: "production",
    no: "02",
    title: "Music Production & Studio Services",
    intro:
      "We help artists and churches turn musical ideas into professional recordings, from initial production through the final mix.",
    items: [
      "Music production and arrangement",
      "Studio recording and vocal production",
      "Mixing and mastering",
      "Songwriting and recording sessions",
      "Live recording and album production",
    ],
    bestFor: "Independent artists, worship leaders, churches, songwriters, and music organizations.",
    pricing: "Custom quotes based on client needs, song lengths and other variables.",
    image: "/images/studio-reggie.webp",
    pos: "50% 55%",
  },
  {
    id: "worship",
    no: "03",
    title: "Worship Leading & Music Direction",
    intro:
      "We provide experienced worship leadership and musical direction for church services, conferences, worship nights, and special events.",
    items: [
      "Guest worship leading",
      "Music direction for services and events",
      "Band preparation and rehearsal direction",
      "Setlist planning and musical arrangements",
      "Live music coordination",
    ],
    bestFor: "Churches, conferences, artists, and event organizers seeking strong musical leadership.",
    pricing: "Custom quotes based on event requirements, preparation, and travel.",
    image: "/images/worship-bass.webp",
  },
];

export const STEPS = [
  { no: "01", title: "Reach out", text: "Email us or send an inquiry with a brief description of your needs." },
  { no: "02", title: "Let's connect", text: "We'll discuss your goals, timeline, and expectations." },
  { no: "03", title: "Receive a proposal", text: "We'll recommend the right services and provide pricing." },
  { no: "04", title: "Get started", text: "Once the proposal and agreement are approved, we'll begin working together." },
];

export const FAQS = [
  { q: "Who do you work with?", a: "We serve churches, ministries, independent artists, worship leaders, songwriters, and creative organizations." },
  { q: "Do you work outside Charlotte, NC?", a: "Yes. We serve clients throughout the Carolinas and offer remote services nationwide. On-site engagements and travel are available by arrangement." },
  { q: "Can I book a single service?", a: "Absolutely. You can book an individual service, a specific project, or an ongoing consulting engagement." },
  { q: "Do you offer customized packages?", a: "Yes. We tailor our services to your goals, needs, timeline, and budget." },
  { q: "How do I request pricing or book a service?", a: "Email admin@rhettco.org or send an inquiry using the form below." },
];

export const SERVICE_OPTIONS = [
  "Church Consulting & Worship Development",
  "Music Production & Studio Services",
  "Mixing & Mastering",
  "Worship Leading & Music Direction",
  "Not sure yet / Multiple services",
];

export const BUDGET_OPTIONS = ["Under $1,000", "$1,000 – $2,500", "$2,500 – $5,000", "$5,000 – $10,000", "$10,000+", "Prefer to discuss"];

export const CONFIRMATION =
  "Thank you for contacting The Rhett Co LLC! We've received your inquiry and look forward to learning more about your vision. Our team will be in touch soon.";

export const NAV = [
  { id: "about", label: "About" },
  { id: "leadership", label: "Leadership" },
  { id: "services", label: "Services" },
  { id: "process", label: "Process" },
  { id: "faq", label: "FAQ" },
];
